import AccCheckerViewState from '../store/schema/AccCheckerViewState';

export default function createAccCheckerViewState(): AccCheckerViewState {
    return {
        isOpen: false,
        errors: [],
    };
}
